<template>
  <div v-show="createdGroupVisible" class="create_group">
    <h1>添加分组</h1>
    <img :src="close" alt="关闭" @click="groupClose" />
    <label>
      <span class="group_name">分组名称</span>
      <span class="create_input">
        <input type="text" @keyup="groupKeyUp" />
      </span>
      <span class="create_handle">
        <span @click="groupClose">取消</span>
        <span @click="creatGroup">确定</span>
      </span>
    </label>
  </div>
</template>

<script>
export default {
  name: "createGroup",
  data() {
    return {
      close: require("@/common/assets/close.png"),
    };
  },
  props: {
    createdGroupVisible: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    groupClose() {
      this.$emit("groupClose");
    },
    creatGroup() {
      this.$emit("creatGroup");
    },
    groupKeyUp($event) {
      this.$emit("groupKeyUp", $event);
    },
  },
};
</script>

<style lang="less" scoped>
.create_group {
  width: 740px;
  height: 340px;
  margin-left: calc(540px / 2 - 740px / 2);
  margin-top: calc(700px / 2 - 400px / 2);
  border-radius: 8px;
  background-color: #fff;
  position: fixed;
  z-index: 1002;
  box-shadow: 1px 1px 10px #3e3e3e;
  label::after {
    content: "";
    clear: both;
    display: inline-block;
  }
  label {
    // border: solid 1px;
    width: 100%;
    // height: 60px;
    box-sizing: border-box;
    display: inline-block;
    .group_name {
      font-size: 18px;
      font-family: SourceHanSansCN-Medium, SourceHanSansCN;
      font-weight: 500;
      color: #333333;
      line-height: 27px;
      float: left;
      width: 90%;
      display: inline-block;
      //   border: solid 1px;
      margin-left: calc(100% / 2 - 90% / 2);
    }
    .create_input {
      width: 100%;
      display: inline-block;
      height: 60px;
      margin-top: 10px;
      float: left;
      input {
        border-radius: 8px;
        width: 90%;
        height: 60px;
        font-size: 18px;
        text-indent: 0.5em;
        margin-left: calc(100% / 2 - 90% / 2);
        box-sizing: border-box;
        display: inline-block;
        border: solid 1px #ccc;
      }
    }
    .create_handle {
      width: 28%;
      padding: 0 20px;
      box-sizing: border-box;
      height: 36px;
      margin-top: 30px;
      float: right;
      //   border: solid 1px;
      display: inline-block;
      display: flex;
      justify-content: space-around;
      span {
        border-radius: 2px;
        font-size: 16px;
        text-align: center;
        line-height: 36px;
        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        font-weight: 400;
        color: #ffffff;
        cursor: pointer;
      }
      span:first-child {
        display: inline-block;
        width: 70px;
        height: 36px;
        background: #cdcdcd;
      }
      span:last-child {
        display: inline-block;
        width: 70px;
        height: 36px;
        background: #20a0ff;
      }
    }
  }
}
.create_group > h1 {
  width: 100%;
  height: 90px;
  box-sizing: border-box;
  border: solid 1px #ccc;
  border-top: none;
  border-left: none;
  border-right: none;
  font-size: 26px;
  font-family: SourceHanSansCN-Medium, SourceHanSansCN;
  font-weight: 600;
  line-height: 90px;
  text-align: center;
  color: #000000;
}
.create_group > img {
  position: absolute;
  right: 20px;
  top: 20px;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/searchPopup/create-group.vue